module.exports = __webpack_public_path__ + "static/media/ic_star.4f3b1f92.svg";